import { render, staticRenderFns } from "./ClubColumn.vue?vue&type=template&id=0960ab70&"
import script from "./ClubColumn.vue?vue&type=script&lang=js&"
export * from "./ClubColumn.vue?vue&type=script&lang=js&"
import style0 from "./ClubColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports